import { LcarsPanel } from '../components/layout/LcarsPanel';

export function History() {
  return (
    <div class="page">
      <LcarsPanel color="var(--eggplant)" title="History">
        <div style={{ padding: '24px 16px', fontFamily: 'var(--mono)', fontSize: '12px', color: 'var(--text-dim)' }}>
          Coming soon — Publication history with performance metrics and analytics.
        </div>
      </LcarsPanel>
    </div>
  );
}
